import React, { ReactElement, useEffect, useMemo } from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import { formatDecimalNumber } from '../../../../../../../1stlog-ui/src/utils/format'
import { useProductSettings } from '../../../../Products'
import { getVolumeWeight } from './utils'

const Wrapper = styled.div``

const validate = (value: string | null): string | null => value

type TVolumeWeightProps = {
  readonly?: boolean
}

const VolumeWeight = (props: TVolumeWeightProps): ReactElement => {
  const { readonly } = props

  const {
    volumeWeightFactor,
    showVolumeWeight,
    maxVolumeWeight = 0,
    isMeasurementsHidden,
  } = useProductSettings()

  const height = useField('height')
  const width = useField('width')
  const length = useField('length')
  const weight = useField('weight')

  const value = useMemo(
    () =>
      showVolumeWeight
        ? getVolumeWeight({
            height,
            width,
            length,
            divisor: volumeWeightFactor,
          })
        : 0,
    [height, width, length, weight, volumeWeightFactor, showVolumeWeight],
  )

  const {
    input: { value: isVolumeWeightInvalid, onChange: setIsVolumeWeightInvalid },
  } = useField('validation.isVolumeWeightInvalid', {
    raw: true,
    validate,
    subscribeAll: true,
  })

  useEffect(() => {
    const isInvalid = false // maxVolumeWeight < value
    setIsVolumeWeightInvalid(
      isInvalid ? `Max. ${maxVolumeWeight} kg` : undefined,
    )
  }, [value, maxVolumeWeight])

  const [, setVolumeWeight] = useFieldState('volumeWeight')

  useEffect(() => {
    setTimeout(() => {
      setVolumeWeight(value)
    }, 0)
  }, [value])

  if (!showVolumeWeight || isMeasurementsHidden) {
    return <></>
  }

  return (
    <Wrapper className="mr-3">
      <Label tooltip={i18n.t('volume_weight', 'Volumengewicht')}>
        {i18n.t('volume_weight_short', 'Vol.-Gew.')}
      </Label>
      <h5 className={readonly ? 'mt-1' : 'mt-2'}>
        {formatDecimalNumber(value, 2, 2)} kg
      </h5>
      {isVolumeWeightInvalid && (
        <div className="text-danger mb-1 text-left">
          {isVolumeWeightInvalid}
        </div>
      )}
    </Wrapper>
  )
}

export default VolumeWeight
